<script>
    export default {
        name: 'vue-title',
        props: ['title'],
        watch: {
            title: {
                immediate: true,
                handler() {
                    document.title = this.title;
                }
            }
        },
        // eslint-disable-next-line vue/require-render-return
        render () {

        },
    }
</script>